module.exports = __webpack_public_path__ + "img/rw.e33efd1d.png";